export enum FacadeStates {
  LOADING = 0,
  ONGOING = 1,
  COMPLETE = 2,
  ERROR = 3,
}
